import { render, staticRenderFns } from "./CardVerVotantesGeneral.vue?vue&type=template&id=3272025f"
import script from "./CardVerVotantesGeneral.vue?vue&type=script&lang=js"
export * from "./CardVerVotantesGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports